import { AxiosDefault } from "@/plugins/axios";
import {
  AppInformationItem,
  RuleHistoryItem,
  NewRuleItem
} from "./rule.interface";
import { ApkNetworkTagNoticeItem } from "../apk/apk.interface";

export class RuleService {
  /**
   * 获取app规则统一列表
   */
  static async getAppList(): Promise<AppInformationItem[]> {
    const { data } = await AxiosDefault.get("/bff/rule/appList");
    return data.applist || [];
  }

  /**
   * 获取单个app信息
   */
  static async getOneApp(packageName: string): Promise<AppInformationItem> {
    const { data } = await AxiosDefault.get(
      `/bff/user/notice/networkTags?packageName=${packageName}`
    );
    return data || {};
  }
  static async getOneAppWare(id: string): Promise<AppInformationItem> {
    const { data } = await AxiosDefault.get(
      `/bff/user/notice/networkTags?id=${id}`
    );
    return data || {};
  }

  /**
   * 获取历史变更日志列表
   */
  static async getAllRuleHistory(
    packageName: string
  ): Promise<RuleHistoryItem[]> {
    const { data } = await AxiosDefault.get(
      `/bff/rule/getAllHistory?packageName=${packageName}`
    );
    return data || {};
  }

  /**
   * 获取历史日志
   */
  static async getAllRuleHistoryIn(id: string): Promise<RuleHistoryItem[]> {
    const { data } = await AxiosDefault.get(`/bff/rule/getAllHistory?id=${id}`);
    return data || {};
  }

  /**
   * 增加规则
   */
  static async postNewRule(
    packageName: string,
    payload: NewRuleItem
  ): Promise<void> {
    await AxiosDefault.put(
      `/bff/user/notice/networkTag?packageName=${packageName}`,
      payload
    );
  }
  /**
   * 内部维护-更新规则
   */
  static async postNewRuleIn(id: string, payload: NewRuleItem): Promise<void> {
    await AxiosDefault.put(`/bff/user/notice/networkTag?id=${id}`, payload);
  }

  /**
   * 获取21个固定的隐私项
   */
  static async getFixedRules(): Promise<ApkNetworkTagNoticeItem[]> {
    const { data } = await AxiosDefault.get("/bff/user/notice/networkTags");
    return data.rules || [];
  }
}
